import Button from "components/ui/button";
import React from "react";

const SalaryTable = ({ salaries, userRole, onEdit, onCalculate, salaryDefaults }) => {
  return (
    <table className="w-full border-collapse border border-gray-300">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-2 py-1">Employee ID</th>
          <th className="border px-2 py-1">Month</th>
          <th className="border px-2 py-1">Gross Salary</th>
          <th className="border px-2 py-1">Net Salary</th>
          <th className="border px-2 py-1">LOP Deduction</th>
          {userRole === "admin" && <th className="border px-2 py-1">Actions</th>}
        </tr>
      </thead>
      <tbody>
        {salaries.length === 0 ? (
          <tr>
            <td colSpan={userRole === "admin" ? 6 : 5} className="text-center py-2">
              No salary data available
            </td>
          </tr>
        ) : (
          salaries.map((salary) => {
            // Determine if this is a default (create mode) or existing salary (edit mode)
            const isDefault = !salary.id;

            // Calculate gross and net using either existing salary or defaults
            const grossSalary = isDefault
              ? Object.entries(salaryDefaults)
                  .filter(([key]) => !["employee_id", "month", "remarks"].includes(key))
                  .reduce((acc, [, value]) => acc + Number(value || 0), 0)
              : salary.gross_salary;

            const netSalary = isDefault
              ? grossSalary -
                (salaryDefaults.pf_employee || 0) -
                (salaryDefaults.esi_employee || 0) -
                (salaryDefaults.tax_deduction || 0) -
                (salaryDefaults.other_deductions || 0)
              : salary.net_salary;

            return (
              <tr key={salary.id || `${salary.employee_id}-${salary.month}`}>
                <td className="border px-2 py-1">{salary.employee_id || "N/A"}</td>
                <td className="border px-2 py-1">{salary.month || "N/A"}</td>
                <td className="border px-2 py-1">{grossSalary}</td>
                <td className="border px-2 py-1">{netSalary}</td>
                <td className="border px-2 py-1">{salary.lop_deduction || 0}</td>
                {userRole === "admin" && (
                  <td className="border px-2 py-1 space-x-2">
                    <Button onClick={() => onEdit(salary)}>
                      {isDefault ? "Create" : "Edit"}
                    </Button>
                    {!isDefault && <Button onClick={() => onCalculate(salary)}>Calculate</Button>}
                  </td>
                )}
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};

export default SalaryTable;
